import { render, staticRenderFns } from "./SafetyObservationItemCorrection.vue?vue&type=template&id=84101a64&"
import script from "./SafetyObservationItemCorrection.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationItemCorrection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports